<template>
	<div>
		<div class="bio-pane active">
			<div class="search-bar">
				<el-form ref="form" label-width="120px">
					<label>日期 <el-date-picker size="small" style="width:220px" type="daterange" align="right" unlink-panels
							range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
							:picker-options="pickerOptions" v-model="filter.date"
							@change="handleFilter(3, 1, $event)"></el-date-picker></label>
					<div style="display: inline-block;">
						数据源
						<el-select size="small" filterable clearable placeholder="请选择" v-model="filter.dataType"
							@change="handleFilter(3, 2, $event)">
							<el-option v-for="item in sourceList" :key="item.id" :label="item.name"
								:value="item.id"></el-option>
						</el-select>
					</div>
					<div class="flr">
						<el-button type="primary" size="mini" round @click="onShowForm('add')">添加{{ titdata[currentTab].name
						}}</el-button>
						<el-link class="mode noline" :class="{ active: viewMode == 1 }" @click="handleMode(1)"><i
								class="icon-table"></i></el-link>
						<el-link class="mode noline" :class="{ active: viewMode == 2 }" @click="handleMode(2)"><i
								class="icon-chart2"></i></el-link>
					</div>
				</el-form>
			</div>

			<div class="pane-mode table-wrap" :class="{ active: viewMode == 1 }">
				<el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border
					:data="list.data" v-loading="isLoading">
					<el-table-column prop="lisDate" label="测量时间" show-overflow-tooltip min-width="120"></el-table-column>
					<el-table-column prop="itemResult"
						:label="titdata[currentTab].tit + '(' + titdata[currentTab].unit + ')'" min-width="120">
						<template slot-scope="scope">
							<span class="lv" :class="['lv' + scope.row.level]">{{ scope.row.itemResult ?
								scope.row.itemResult :
								"未测量" }}</span>
							{{
								scope.row.itemRange
								? "(" + scope.row.itemRange + ")"
								: ""
							}}
						</template>
					</el-table-column>
					<el-table-column prop="itemTip" label="结果" width="100">
						<template slot-scope="scope">
							<span class="lv" :class="['lv' + scope.row.level]">{{ scope.row.itemTip }}</span>
						</template>
					</el-table-column>

					<el-table-column prop="dataType" label="数据源" width="100"></el-table-column>

					<el-table-column fixed="right" label="操作" width="100">
						<template slot-scope="scope">
							<div class="tab-action" v-if="scope.row.dataType == '后台录入'">
								<el-tooltip content="修改" slot="reference" placement="top" :enterable="false">
									<i @click="onShowForm(scope.row)" class="el-icon-edit" />
								</el-tooltip>
								<el-popconfirm confirmButtonText='删除' title="确定删除吗？" @confirm="delItem(scope.row)">
									<el-tooltip content="删除" slot="reference" placement="top" :enterable="false">
										<i class="el-icon-delete"></i>
									</el-tooltip>
								</el-popconfirm>
							</div>
						</template>
					</el-table-column>
				</el-table>
				<div class="pagination">
					<el-row>
						<el-col :span="12">
							<div class="record">当前是第<span
									v-text="(filter.pageNumber - 1) * filter.pageSize + 1"></span>条至第<span
									v-text="Math.min(list.total, (filter.pageNumber - 1) * filter.pageSize + filter.pageSize)"></span>数据
							</div>
							<div class="record">总计<span v-text="list.total"></span>条记录</div>
						</el-col>
						<el-col :span="12" style="text-align: right;">
							<el-pagination :disabled="isLoading" layout="sizes, prev, pager, next"
								:page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]" prev-text="上一页" next-text="下一页"
								:current-page="list.current" :page-size="filter.pageSize" :total="list.total"
								@size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
						</el-col>
					</el-row>
				</div>
			</div>
			<div class="pane-mode chart" :class="{ active: viewMode == 2 }">
				<chart :options="chartOpts"></chart>
			</div>
		</div>


		<el-dialog :title.sync="dialogTit" width="550px" center :visible.sync="isFormActive">
			<el-form ref="form" label-width="120px" :rules="rules" :model="form">
				<el-form-item label="测量时间：" prop="lisDate" class="t-label">
					<el-date-picker v-model="form.lisDate" value-format="yyyy-MM-dd HH:mm:ss" :clearable="false"
						type="datetime"></el-date-picker>
				</el-form-item>
				<div v-if="currentTab == 9" style="display: flex;">
					<el-form-item :label="titdata[currentTab].tit + '(' + titdata[currentTab].unit + ')'" prop="radio"
						class="requireLabel">
						<el-radio-group v-model="form.radio">
							<el-radio label="1">&lt;1.00*10^2</el-radio>
							<el-radio label="2">阳性</el-radio>
						</el-radio-group>
					</el-form-item>
					<div v-if="form.radio == 2" class="subinp">
						<el-form-item prop="left">
							<el-input clearable v-model="form.left" class="l-inp"></el-input>
						</el-form-item>
						*10^
						<el-form-item prop="right">
							<el-input clearable v-model="form.right" class="l-inp"></el-input>
						</el-form-item>
					</div>

				</div>
				<div v-else-if="currentTab == 10" style="display: flex;">
					<el-form-item :label="titdata[currentTab].tit + '(' + titdata[currentTab].unit + ')'" prop="radio"
						class="requireLabel">
						<el-radio-group v-model="form.radio">
							<el-radio label="1">未检出</el-radio>
							<el-radio label="2">检出结果</el-radio>
						</el-radio-group>
					</el-form-item>
					<div v-if="form.radio == 2" class="subinp">
						<el-form-item prop="left">
							<el-input clearable v-model="form.left" class="l-inp"></el-input>
						</el-form-item>
						E+
						<el-form-item prop="right">
							<el-input clearable v-model="form.right" class="l-inp"></el-input>
						</el-form-item>
					</div>
				</div>
				<el-form-item v-else :label="titdata[currentTab].tit" prop="itemResult">
					<el-input clearable v-model="form.itemResult"></el-input> {{ titdata[currentTab].unit }}
				</el-form-item>
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button type="primary" :loading="isLoading" @click="onSave">保 存</el-button>
			</div>
		</el-dialog>


	</div>
</template>

<script>
import mixin from '@/views/mixin';
import { Chart } from 'highcharts-vue';
import api from '@/service/api.js';
import dayjs from 'dayjs';
import { throttle } from "throttle-debounce";

export default {
	components: { Chart },
	mixins: [mixin],
	props: {
		patientId: { required: true },
		currentTab: { required: true }

	},
	data() {
		return {
			noSidebar: true,
			sourceList: [],
			dialogTit: '',
			filter: {
				dataType: null,//0院中Pad、1化验检验、3后台录入、4患者自测
				id: null,
				pageNumber: 1,
				pageSize: 10,
				patientId: null,
				recordId: '',
				resultType: null
			},
			titdata: {
				9: {
					name: '乙肝DNA测定',
					tit: 'HBV-DNA',
					unit: 'IU/ml',
				},
				10: {
					name: '丙肝RNA测定',
					tit: 'HCV-RNA',
					unit: 'IU/ml',
				},
				11: {
					name: '谷丙转氨酶',
					tit: 'ALT',
					unit: 'U/L'
				},
				12: {
					name: '谷草转氨酶',
					tit: 'AST',
					unit: 'U/L'
				},
				13: {
					name: '甲胎蛋白',
					tit: 'AFP',
					unit: 'ng/ml'
				},
			},
			viewMode: 1,
			isFormActive: false,
			rules: {
				left: [{ required: true, message: '请输入' }],
				right: [{ required: true, message: '请输入' }],
				radio: [{ required: true, message: '请选择' }],
			},
			form: {
				patientId: 0,
				lisDate: undefined,
				itemResult: undefined,
				dataType: 3,
				radio: null,
				left: null,
				right: null
			},
			list: { pageSize: 30, pageCount: 50, total: 300, data: [] },
			chartOpts: {
				title: {
					style: { color: '#2f4b6a' },
					// text: '最近1468天趋势图',
					text: null,
				},
				subtitle: {
					useHTML: true,
					style: { color: '#55759b' },
					text: undefined,
				},
				legend: {
					x: -50,
					borderWidth: 1,
					borderRadius: 5,
					layout: 'vertical',
					align: 'right',
					verticalAlign: 'top',
					floating: true
				},
				tooltip: { valueSuffix: 'umol/L' },
				credits: { enabled: false },
				yAxis: {
					title: { style: { color: '#55759b' }, text: '(umol/L)' },
				},
				xAxis: {
					categories: undefined
				},
				plotOptions: {
					line: {
						dataLabels: { enabled: true },
						enableMouseTracking: true
					}
				},
				series: undefined
			}
		}
	},
	created() {
		// let query = this.$route.query;
		this.filter.patientId = this.patientId;
		this.loadList();

		// 获取 来源下拉
		api.getPatientBioSourceType({}).then((res) => {
			if (res.code == 1000 && res.data) {
				this.sourceList = res.data;
			}
		});
	},
	watch: {
		currentTab(val) {
			console.log(val, '=====99');
			this.$refs.form.resetFields();
			this.loadList();
		}
	},
	methods: {
		async loadList() {
			let res;
			switch (this.currentTab) {
				case 9:
					res = await api.getListPatientHbvDNA(this.filter);
					break;
				case 10:
					res = await api.getListPatientBGDNA(this.filter);
					break;
				case 11:
					res = await api.getListPatientALT(this.filter);
					break;
				case 12:
					res = await api.getListPatientAST(this.filter);
					break;
				case 13:
					res = await api.getListPatientAFP(this.filter);
					break;

			}

			// 获取 血压数据
			const filter = JSON.parse(JSON.stringify(this.filter));
			filter.date = undefined;
			if (res.code == 1000 && res.data) {
				if (res.data) {
					res.data.forEach((item) => {
						item.level = this.getLevel(1, item.itemTip);
					})
					this.list.total = +res.total;
					this.list.current = this.filter.pageNumber;
					this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
					this.list.data = res.data;

					let labels = [];
					let datas = [];
					res.data?.forEach(item => {
						labels.push(item.lisDate);
						datas.push(+item.itemResult);
					});
					// 图表数据
					this.chartOpts.tooltip.valueSuffix = this.titdata[this.currentTab].unit;
					this.chartOpts.yAxis.title.text = this.titdata[this.currentTab].unit;
					this.chartOpts.xAxis.categories = labels.reverse();
					this.chartOpts.series = [
						{
							name: this.titdata[this.currentTab].name,
							color: 'blue',
							data: datas.reverse()
						}
					];
					if (labels.length > 0) {
						this.chartOpts.subtitle.text = `<div>${this.titdata[this.currentTab].name}(峰值:${Math.max(...datas)}${this.titdata[this.currentTab].unit} 谷值:${Math.min(...datas)}${this.titdata[this.currentTab].unit}均值: ${this.MathAvg(datas)}${this.titdata[this.currentTab].unit})</div>`;
					} else {
						this.chartOpts.subtitle.text = undefined;
					}

				}
			}

		},
		// 求平均值
		MathAvg(arr) {
			return (arr.reduce((pre, cur) => pre + cur) / arr.length).toFixed(1);
		},
		handleMode(key) {
			this.viewMode = key;
		},
		handleFilter(key, val) {
			if (val == 1) {
				// 时间筛选
				if (this.filter.date) {
					this.filter.startTime = dayjs(this.filter.date[0]).format('YYYY-MM-DD 00:00:00');
					this.filter.endTime = dayjs(this.filter.date[1]).format('YYYY-MM-DD 23:59:59');
				} else {
					this.filter.startTime = '';
					this.filter.endTime = '';
				}
			}
			this.filter.pageNumber = 1;
			this.loadList();
		},
		onShowForm(item) {
			console.log(item,'=====ii');
			this.form.left='';
			this.form.right='';
			this.isFormActive = true;
			this.$refs['form'].resetFields();
			if (item == 'add') {
				this.dialogTit = `添加${this.titdata[this.currentTab].name}`
				this.form.lisDate = dayjs().format('YYYY-MM-DD HH:mm:ss');
				this.form.itemResult = undefined;
				this.form.id = undefined;
			} else {
				this.dialogTit = `修改${this.titdata[this.currentTab].name}`
				this.form.lisDate = item.lisDate;
				this.form.itemResult = item.itemResult;
				this.form.id = item.id;
				if(this.currentTab==10){
					if(item.itemResult=='TargetNotDetected'){
						this.form.radio='1';
						
					}else{
						this.form.radio='2';
						let r=item.itemResult.split('E+');
						console.log(r,'===r');
						this.form.left=r[0];
						this.form.right=r[1];
					}
					console.log(this.form,'====ff');
				}else if(this.currentTab==9){
					if(item.itemResult=='<1.00*10^2'){
						this.form.radio='1';
					}else{
						this.form.radio='2';
						let r=item.itemResult.split('*10^');
						this.form.left=r[0];
						this.form.right=r[1];
					}
				}
			}
		},	
		onSave: throttle(3000, true, function () {
			this.$refs['form'].validate(async (valid) => {

				if (valid) {
					if (this.currentTab == 9) {
						if (this.form.radio == 1) {
							this.form.itemResult = '<1.00*10^2';
						} else if (this.form.radio == 2) {
							this.form.itemResult = '阳性' + this.form.left + '*10^' + this.form.right
						}
					} else if (this.currentTab == 10) {
						if (this.form.radio == 1) {
							this.form.itemResult = 'TargetNotDetected';
						} else if (this.form.radio == 2) {
							this.form.itemResult = this.form.left + 'E+' + this.form.right
						}
					}
					this.form.patientId = this.patientId;
					if (this.dialogTit == `添加${this.titdata[this.currentTab].name}`) {
						let res;
						switch (this.currentTab) {
							case 9:

								res = await api.addListPatientHbvDNA(this.form);
								break;
							case 10:

								res = await api.addListPatientBGDNA(this.form);
								break;
							case 11:
								res = await api.addListPatientALT(this.form);
								break;
							case 12:
								res = await api.addListPatientAST(this.form);
								break;
							case 13:
								res = await api.addPatientAFP(this.form);
								break;

						}
						if (res.code != 1000) {
							this.$message.console.error(res.msg);
							return;
						}
						this.$message.success('添加成功');

					} else {
						let res;
						switch (this.currentTab) {
							case 9:
								res = await api.updateListPatientHbvDNA(this.form);
								break;
							case 10:
								res = await api.updateListPatientBGDNA(this.form);
								break;
							case 11:
								res = await api.updateListPatientALT(this.form);
								break;
							case 12:
								res = await api.updateListPatientAST(this.form);
								break;
							case 13:
								res = await api.updatePatientAFP(this.form);
								break;

						}
						if (res.code != 1000) {
							this.$message.console.error(res.msg);
							return;
						}
						this.$message.success('修改成功');
					}
					this.isFormActive = false;
					this.loadList();
				}
			});
		}),
		handleSizeChange(v) {
			this.filter.pageSize = v;
			this.filter.pageNumber = 1;
			this.loadList();
		},
		handleCurrentChange(v) {
			this.filter.pageNumber = v;
			this.loadList();
		},
		getLevel(v, key) {
			if (v != 0) {
				switch (key) {
					case '高': return 4;
					case '低': return 1;
					case '阳性': return 4;
					default: return 0;
				}
			}
		},
		async delItem(item) {
			let res = await api.delLabLisPatient([String(item.id)]);
			if (res.code == 1000) {
				this.$message.success('删除成功');
				this.loadList();
			}
		}
	}
}	
</script>
<style lang="less" scoped>
::v-deep .t-label {
	.el-form-item__label {
		margin-left: 15px;
	}
}

.requireLabel {
	::v-deep .el-form-item__label {
		width: auto !important;
	}

	::v-deep .el-form-item__content {
		display: flex;
	}


}

.subinp {
	display: flex;
	align-items: center;
	margin-bottom: 22px;

	::v-deep .el-form-item {
		margin-bottom: 0 !important;
	}

	::v-deep .el-form-item__content {
		margin-left: 0 !important;
	}

	::v-deep .l-inp {
		width: 46px;
		margin-right: 20px;
		margin-left: 4px;

		.el-input__inner {
			width: 50px;
			padding: 0 16px 0 4px;
		}

		.el-input__suffix {
			opacity: 1;
			display: block;
			right: -6px;
		}
	}
}

.tab-action {
	display: flex;
	justify-content: center;
}
</style>